// coco+ 専用「配信」タブ画面（ライブ配信一覧）の文言
export const cocoplusLive = {
  watchCta: "配信を見る",
  age: (args: { age: string | number }) => `${args.age}歳`,
} as const;
